module.exports = __webpack_public_path__ + "img/Aperature Priority-Low.55356c2b.jpg";